import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase-config';
import { CustomProductBulkTarget } from '../types/customProductBulkActions';
import { unwrapCallableData } from './callableResponse';

type DeleteAllCustomProductsRequest = {
    companyId: string
} & Partial<CustomProductBulkTarget>;

interface DeleteAllCustomProductsResponse {
    companyId: string;
    deletedCount?: number;
    requestedCount?: number;
    scope?: CustomProductBulkTarget['scope'];
}

const deleteAllCustomProducts = async (companyId: string, target?: CustomProductBulkTarget): Promise<DeleteAllCustomProductsResponse> => {
    const analyzeShopifyShop = httpsCallable<DeleteAllCustomProductsRequest, DeleteAllCustomProductsResponse>(functions, 'delete_all_custom_products');
    const result = await analyzeShopifyShop({ companyId, ...target });
    return unwrapCallableData<DeleteAllCustomProductsResponse>(result.data);
};



export { deleteAllCustomProducts };
